// Sivir — Ricochet (W): throws her crossblade at the primary target, then bounces
// to up to 2 nearby enemies. Each hit deals physical damage (bounces deal 40% AD).
// The blade does not return — it fades after the final bounce.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Unit } from "../Unit";
import type { Ability, AbilityHit } from "./Ability";

export const sivirRicochet: Ability = {
  id: "sivirRicochet",
  displayName: "Ricochet",
  description: "Throws her crossblade at the nearest enemy, bouncing to up to 2 others. Primary hit: 1.0× AD. Bounce hits: 0.4× AD.",
  iconId: "SivirW",

  targetShape({ caster, target, combat }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const bounces = nearestOthers(target, combat.livingUnitsOf(enemyTeam), 2);
    return [target.pos, ...bounces.map(e => e.pos)];
  },

  computeHits({ caster, target, combat }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const primaryDmg = physicalDamage(stats.ad * 1.0);
    const bounceDmg  = physicalDamage(stats.ad * 0.4);
    const enemyTeam  = caster.team === "player" ? "enemy" : "player";
    const bounces    = nearestOthers(target, combat.livingUnitsOf(enemyTeam), 2);

    return [
      { target, amount: primaryDmg, type: "physical", sivirBounce: true, chainStop: true as const },
      ...bounces.map(e => ({ target: e, amount: bounceDmg, type: "physical" as const, sivirBounce: true as const, chainStop: true as const })),
    ];
  },
};

function nearestOthers(primary: Unit, all: Unit[], count: number): Unit[] {
  return all
    .filter(e => e.id !== primary.id)
    .sort((a, b) => hexDist(a, primary) - hexDist(b, primary))
    .slice(0, count);
}

function hexDist(a: Unit, b: Unit): number {
  const dq = a.pos.q - b.pos.q;
  const dr = a.pos.r - b.pos.r;
  return Math.abs(dq) + Math.abs(dr) + Math.abs(dq + dr);
}
